/*eslint-disable */
var interval;

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import {bus} from '@/main';
import countries from '@/services/country.json';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
export default {
  name: 'request-for-demo-popup',
  components: {
    Multiselect,
    datetime: Datetime
  },
  props: [
    'meetingID'
  ],
  data () {
    return {
      first_name:'',
      last_name:'',
      email:'',
      phone_no:'',
      company_name:'',
      num_of_attendees:'',
      country:'',
      city:'',
      live_demo_site:'',
      actvSlide:false,
      submitted:false,
      sectionHide:false,
      select_option:'company',
      minDatetime:new Date().toISOString(),
      countryList:[],
      slotTimeList:null,
      slotTimeListArr:[],
      demoReqFormConfirmationState:false,
      selectedTimeZone:'',
      selectedTimeSlot:'',
      selectedTimeSlotIndex:'',
      timeData:null,
      timeDataArr:[],
      isClickOutsideEnabledOfC:false,
      isClickOutsideEnabledOfZone:false,
      isClickOutsideEnabledOfSlot:false,
      demoReqFirstScreenState:true,
      otp:'',
      countDown: 600,
      displayTimes:'10:00'
    }
  },
  computed: {
  },
  mounted () {
    setTimeout(() => {
      this.actvSlide = true
    }, 800)
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key],
        value: key
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.$store.dispatch('getTimeSlotsWithZoneAction').then((res) => {
      this.slotTimeList = res.data
      // Convert the data into an array of objects
      if(!this.slotTimeList) return;
      this.slotTimeListArr = Object.entries(this.slotTimeList).map(([name, value]) => ({ name, value }));
    })
    this.$store.dispatch('getTimeSlotsforDemoAction').then((res) => {
      this.timeData = res.data.data
      if(this.timeData){
        // Convert the data into an array of objects
        this.timeDataArr = Object.entries(this.timeData).map(([time, timestamp]) => ({ time, timestamp }));
      }
    })
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        interval = setTimeout(() => {
          this.countDown -= 1;
          const minutes = Math.floor(this.countDown / 60);
          const remainingSeconds = this.countDown % 60;
          this.displayTimes = minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');
          this.countDownTimer();
        }, 1000);
      }
    },
    backToFirstScreenMethod(){
     var firstSection = document.getElementsByClassName('slide_actv');
      firstSection[0].click();
    },
    scrollBackOfDemoReqMethod(){
      bus.$emit('moveToFirstInSliderBus', true)
    },
    enabledScrollContryFieldMethod(){
      if(this.isClickOutsideEnabledOfC){
        bus.$emit('movingFlagStateBus', false)
        this.isClickOutsideEnabledOfC = false
      }
    },
    enabledScrollZoneFieldMethod(){
      if(this.isClickOutsideEnabledOfZone){
        bus.$emit('movingFlagStateBus', false)
        this.isClickOutsideEnabledOfZone = false
      }
    },
    enabledScrollSlotFieldMethod(){
      if(this.isClickOutsideEnabledOfSlot){
        bus.$emit('movingFlagStateBus', false)
        this.isClickOutsideEnabledOfSlot = false
      }
    },
    disabledScrollContryFieldMethod(){
      bus.$emit('movingFlagStateBus', true)
      this.isClickOutsideEnabledOfC = true
    },
    disabledScrollZoneFieldMethod(){
      bus.$emit('movingFlagStateBus', true)
      this.isClickOutsideEnabledOfZone = true
    },
    disabledScrollSlotFieldMethod(){
      bus.$emit('movingFlagStateBus', true)
      this.isClickOutsideEnabledOfSlot = true
    },
    clearFieldsMethod(){
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.phone_no = '';
      this.city = '';
      this.country = '';
      this.live_demo_site = '';
      this.num_of_attendees = '';
      this.company_name = '';
      this.select_option = 'company';
      this.$validator.reset();
      this.selectedTimeSlot = '';
      this.selectedTimeZone = '';
      this.otp = "";
      this.clearTimeOutMethod();
    },
    clearTimeOutMethod(){
      clearInterval(interval);
      this.displayTimes = '10:00';
      this.countDown = 600; 
    },
    demoReqFormConfirmationMethod(){
      this.clearFieldsMethod();
      this.demoReqFormConfirmationState = false;
      this.demoReqFirstScreenState = true;
      
    },
    resentOTPGenerateMethod(){
      let data = {
        email:this.email,
      }
      this.$store.dispatch('otpGenerateForDemoReqAction', data).then((res) => {  
        toast.success(res.data.msg || 'Request processed successfully.');
        this.clearTimeOutMethod();
        this.countDownTimer();
      })
    },
    otpGenerateForDemoReqMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            email:this.email,
          }
          this.$store.dispatch('otpGenerateForDemoReqAction', data)
            .then((res) => {  
              this.countDownTimer();
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted =  false;
              this.demoReqFirstScreenState = false;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.message || err.data.msg);
            })
          return;
        }
      })
    }, 
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            title:this.select_option,
            fname:this.first_name,
            lname:this.last_name,
            otp:this.otp,
            mobile:this.phone_no,
            email:this.email,
            city:this.city,
            country:this.country.value,
            // country:'MC',
            date:this.live_demo_site,
            time:this.timeDataArr[this.handleSelect(this.selectedTimeSlot)].timestamp,
            num_of_attendees:this.num_of_attendees,
            company_name:this.company_name,
            timezone:this.selectedTimeZone.name,
            timeslot:this.selectedTimeSlot
          }
          this.$store.dispatch('requestForDemoAction', data)
            .then((res) => {  
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted =  false;
              this.demoReqFormConfirmationState = true;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    }, 
    handleSelect(selectedValue) {
      // Find the index of the selected item in the options array
      const index = this.selectedTimeZone.value.findIndex((option) => option === selectedValue);
      // Update the selectedIndex
      return index;
    },
  },
  watch: {
    country(newVal, oldVal){
      if(newVal){
        this.enabledScrollContryFieldMethod();
      }
    },
    selectedTimeZone(newVal, oldVal){
      if(newVal){
        this.enabledScrollZoneFieldMethod();
      }
    },
    selectedTimeSlot(newVal, oldVal){
      if(newVal){
        this.enabledScrollSlotFieldMethod();
      }
    }
  },
}